import { render, staticRenderFns } from "./CreateOrderDispatchInvoice.vue?vue&type=template&id=8ce7ddce&scoped=true&"
import script from "./CreateOrderDispatchInvoice.vue?vue&type=script&lang=js&"
export * from "./CreateOrderDispatchInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce7ddce",
  null
  
)

export default component.exports